/**
 * Este service atualmente é usado para definir os campos utilizados por cada empresa/ERP
 * Atualmente usamos isso para as alçadas
 */
import CadastrosAdicionais from '@/enums/cadastros-adicionais';

const campos = {
  compras: {
    TOTVS: [CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key, CadastrosAdicionais.keys.NATUREZA.key],
    SANKHYA: [CadastrosAdicionais.keys.NATUREZA.key],
    SENIOR: [CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key],
    SENIOR_TEIXEIRA: [CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key],
    LM: [CadastrosAdicionais.keys.TIPO_COBRANCA.key],
    USEALL: [CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key],
    USEALL_SETUP: [
      CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
      CadastrosAdicionais.keys.OBSERVACAO_INTERNA.key,
    ],
  },
  comprasItens: {
    TOTVS: [
      CadastrosAdicionais.keys.ARMAZEM.key,
      CadastrosAdicionais.keys.CONTA_CONTABIL.key,
    ],
    NEO: [
      CadastrosAdicionais.keys.CONTA_CONTABIL.key,
    ],
    SENIOR: [
      CadastrosAdicionais.keys.ARMAZEM.key,
    ],
    SENIOR_TEIXEIRA: [
      CadastrosAdicionais.keys.ARMAZEM.key,
      CadastrosAdicionais.keys.CONTA_CONTABIL.key,
      CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
    ],
    NEO_G7: [
      CadastrosAdicionais.keys.CONTA_CONTABIL.key,
    ],
    CRM_SOLUCOES: [
      CadastrosAdicionais.keys.CONTA_DESPESA.key,
    ],
    SENIOR_MEGA: [
      CadastrosAdicionais.keys.OPERACAO.key,
      CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
    ],
    NEO_GABRIELLA: [
      CadastrosAdicionais.keys.CONTA_CONTABIL.key,
    ],
    CASA_SHOPPING: [
      CadastrosAdicionais.keys.CONTA_DESPESA.key,
    ],
    FOCCO: [
      CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
    ],
  },
  requisicaoItens: {
    CRM_SOLUCOES: [
      CadastrosAdicionais.keys.CONTA_DESPESA.key,
    ],
    TOTVS: [
      CadastrosAdicionais.keys.ARMAZEM.key,
    ],
    SENIOR_MEGA: [
      CadastrosAdicionais.keys.OPERACAO.key,
      CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
    ],
    CASA_SHOPPING: [
      CadastrosAdicionais.keys.CONTA_DESPESA.key,
    ],
    FOCCO: [
      CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
    ],
  },
};

const getCamposGeraisCompraPorErp = (tipoErp) => {
  const camposCompra = campos.compras[tipoErp] || [];
  const camposCompraItens = campos.comprasItens[tipoErp] || [];
  return Promise.resolve({
    data: [...camposCompra, ...camposCompraItens],
  });
};

const getCamposGeraisRequisicaoPorErp = (tipoErp) => {
  const camposRequisicaoItens = campos.requisicaoItens[tipoErp] || [];
  return Promise.resolve({
    data: camposRequisicaoItens,
  });
};

export default {
  getCamposGeraisCompraPorErp,
  getCamposGeraisRequisicaoPorErp,
};
